import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { IMPERSONATION_NAMESPACE } from '../../common/constants/impersonation';
import { confirmStopImpersonation } from './confirmStopImpersonation';

// Takes the place of "Log out" in an impersonation tab; rendered only there, so other users never load the namespace.
export const StopImpersonationButton = ({ renderLabel = label => label, ...buttonProps }) => {
    const { t } = useTranslation([IMPERSONATION_NAMESPACE, 'confirmModal']);

    return (
        <Button {...buttonProps} onClick={() => confirmStopImpersonation(t)}>
            {renderLabel(t('stop-impersonating'))}
        </Button>
    );
};
